import React from "reactn";
import SectionThree from "./forms/SectionThree";
import SectionFour from "./forms/SectionFour";
import "../../../assets/css/componentSpecificCss/eventListings.css";

class AddD extends React.Component {
  render() {
    return (
      <div className="cont boxes-row mt-50px center-box">
        <SectionFour vals={this.global.myApplicationProfileInfo} />
      </div>
    );
  }
}

export default AddD;
